import "./Footer.css";

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">

        {/* FOOTER LINK COLUMNS */}
        <div className="footer-grid">

          {/* PRODUCT */}
          <div className="footer-column">
            <div className="footer-heading">
              The index
            </div>

            <div className="footer-links">
              <a href="product.html">
                About
              </a>

              <a href="/data">
                Data
              </a>

            </div>
          </div>

          {/* METHOD */}
          <div className="footer-column">
            <div className="footer-heading">
              Method
            </div>

            <div className="footer-links">
              <a href="methodology.html#panel">
                Newspaper panel
              </a>

              <a href="methodology.html#validation">
                Human audit
              </a>
            </div>
          </div>

          {/* RESEARCH */}
          <div className="footer-column">
            <div className="footer-heading">
              Research
            </div>

            <div className="footer-links">
              <a href="research.html">
                Working paper
              </a>

              <a href="https://osf.io/ep759">
                OSF archive
              </a>
            </div>
          </div>

          {/* CONTACT */}
          <div className="footer-column">
            <div className="footer-heading">
              Contact
            </div>

            <div className="footer-links">
              <a href="contact.html">
                Contact us
              </a>

              {/* <a href="/">
                epu-index.pl
              </a> */}
            </div>
          </div>

        </div>


        <div className="footer-statement">
          Measuring uncertainty
          <span className="footer-statement-accent">.</span>{" "}
          Delivering decision intelligence
          <span className="footer-statement-accent">.</span>
        </div>


        {/* FOOTER META */}
        <div className="footer-meta">

          <span>
            EPU Index Poland · epu-index.pl
          </span>

          <span>
            Landowska · Kłopotek · Zhang
          </span>

          <span>
            Design mock-up · not for publication
          </span>

        </div>

      </div>
    </footer>
  );
}

export default Footer;

